import React, { useEffect, useState } from 'react';
import { pubFile } from './publicI18n';
import { IllustrativeBadge } from '../../components/IllustrativeBadge';

// Antes/Depois com slider + troca de cor (versão pública, tema claro)
export const PublicCompare = ({ token, before, variants, afterId, t }) => {
  const [pos, setPos] = useState(55);
  const [cur, setCur] = useState(afterId);
  useEffect(() => { setCur(afterId || variants[0]?.id); }, [afterId, variants]);
  const current = variants.find((v) => v.id === cur) || variants[0];
  if (!before || !current) return null;
  const ratio = `${before.width || 4} / ${before.height || 3}`;

  return (
    <section className="sales-rise sales-rise-2" data-testid="public-compare">
      <h2 className="text-base md:text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">{t.yourHome}</h2>
      <div className="rounded-3xl overflow-hidden border border-white/80 bg-white/70 backdrop-blur-xl shadow-lg">
        <div className="relative select-none bg-slate-900" style={{ aspectRatio: ratio }} data-testid="public-compare-stage">
          <img src={pubFile(token, current.id)} alt={t.after} className="absolute inset-0 w-full h-full object-contain" draggable={false} />
          <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
            <img src={pubFile(token, before.id)} alt={t.before} className="absolute inset-0 h-full object-contain" style={{ width: `${10000 / pos}%`, maxWidth: 'none' }} draggable={false} />
          </div>
          <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,.4)]" style={{ left: `${pos}%` }}>
            <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-11 w-11 rounded-full bg-white text-teal-700 flex items-center justify-center text-sm font-bold shadow-lg">⇆</span>
          </div>
          <span className="absolute top-3 left-3 rounded-full bg-black/60 text-white px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider">{t.before}</span>
          <span className="absolute top-3 right-3 rounded-full bg-teal-600 text-white px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider">{t.after}</span>
          <IllustrativeBadge text={t.illustrative} className="bottom-3 right-3" testId="public-compare-illustrative" />
          <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" aria-label={t.dragToCompare} data-testid="public-compare-slider" />
        </div>
        <div className="px-4 py-3 flex flex-wrap items-center gap-2" data-testid="public-compare-colors">
          <span className="text-xs text-slate-500 mr-1">{variants.length > 1 ? t.pickColor : t.dragToCompare}</span>
          {variants.map((v) => (
            <button key={v.id} type="button" onClick={() => setCur(v.id)} data-testid={`public-color-${v.color?.id || v.id}`}
              className={`inline-flex items-center gap-2 h-9 px-3 rounded-full border text-xs font-semibold transition-all ${v.id === current.id ? 'border-teal-600 bg-teal-50 text-teal-800 shadow-sm' : 'border-slate-200 bg-white/80 text-slate-700 hover:border-teal-300'}`}>
              <span className="h-3.5 w-3.5 rounded-full border border-black/10" style={{ background: v.color?.hex }} /> {v.color?.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
